import { getCachedData } from "../services/apiService";
import { HOST } from "../constants/HostConstants";

export const filterUsers = async (filter, setAll) => {
  // Cache key: filter users endpoint with filter parameter
  const cacheKey = `llave_cache_/api/user/filterUsers_${JSON.stringify({ filter })}`;

  // Show cached data immediately if available
  const cached = localStorage.getItem(cacheKey);
  let cachedData = null;
  if (cached) {
    try {
      const { data, timestamp } = JSON.parse(cached);
      const isExpired = Date.now() - timestamp > 24 * 60 * 60 * 1000; // 24 hours
      if (!isExpired) {
        cachedData = data;
        setAll(cachedData);
      }
    } catch (e) {
      // Ignore parse errors
    }
  }

  try {
    const response = await fetch(`${HOST}/api/user/filterUsers`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ filter }),
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();

    // Ensure we have an array
    const resultData = Array.isArray(data) ? data : [];

    // Cache the response
    localStorage.setItem(
      cacheKey,
      JSON.stringify({
        data: resultData,
        timestamp: Date.now(),
      }),
    );

    setAll(resultData);
    return resultData;
  } catch (error) {
    // If fetch fails and we have cached data, keep showing it
    if (cachedData) {
      return cachedData;
    }
    // Otherwise set empty array
    setAll([]);
    return [];
  }
};
